import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal, Tooltip, OverlayTrigger} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { coberturasTratamento, papeisAssinatura } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye, FaQuestionCircle } from "react-icons/fa";

import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class TermosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.quemAssinaChange = this.quemAssinaChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            titulo: '',
            texto: '',
            tituloHelper: '',
            textoHelper: '',
            erroLoadRegistro: "",
            termo_id: "",
            quem_assina: [],
            titulo_pagina: "",
            showModal: false,
            loading: false,
        };

        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                termo_id: id,
                titulo_pagina: 'Editando Termo',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/termos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    titulo: dados.titulo,
                    texto: dados.texto,
                    quem_assina: dados.quem_assina ? dados.quem_assina.split(',') : [],
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar termo, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                termo_id: '',
                titulo_pagina: 'Adicionar Termo',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.termo_id) ? '/termos/'+this.state.termo_id+'/' : '/termos/'
        const metodo = (this.state.termo_id) ? 'put' : 'post'

        const quemAssinaString = this.state.quem_assina.join(',');

        formData.append('titulo', this.state.titulo);
        formData.append('texto', this.state.texto);
        if(quemAssinaString) {
            formData.append('quem_assina', quemAssinaString);
        } else {
            formData.append('quem_assina', '');
        }
        

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.termo_id) ? 'Termo atualizado com sucesso' : 'Termo cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.termo_id){
                this.props.router.navigate("/termos");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o termo, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'titulo'){
                        this.setState({ tituloHelper: value })
                    }
                    if(key === 'texto'){
                        this.setState({ textoHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    quemAssinaChange = (papel, isChecked) => {
        const quem_assina = [...this.state.quem_assina];
    
        if (isChecked) {
            quem_assina.push(papel);
        } else {
            const index = quem_assina.indexOf(papel);
            if (index > -1) {
                quem_assina.splice(index, 1);
            }
        }
    
        this.setState({ quem_assina });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleQuillChange = (value) => {
        this.setState({ texto: value });
    };

    handleShowModal() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosTermo" id="tabs-termo" className="aditus-tabs">
                    <Tab eventKey="dadosTermo" title="Dados do Termo">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Termo</h4>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Título</Form.Label>
                                                <Form.Control type="text" name="titulo" required placeholder="Título do Termo" value={this.state.titulo} onChange={this.handleChange} />    
                                                <Form.Text id="formTituloHelper" className="text-danger">{this.state.tituloHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo
                                                    <OverlayTrigger
                                                        placement="right"
                                                        overlay={<Tooltip id="tooltip-right">Clique para ver variáveis disponíveis</Tooltip>}
                                                    >
                                                        <FaQuestionCircle
                                                            onClick={this.handleShowModal}
                                                            style={{ cursor: 'pointer', marginLeft: '5px', color: '#333' }}
                                                        />
                                                    </OverlayTrigger>

                                                </Form.Label>
                                                <ReactQuill
                                                    value={this.state.texto}
                                                    onChange={this.handleQuillChange}
                                                    modules={{
                                                        toolbar: [
                                                            [{ 'header': [1, 2, 3, false] }],
                                                            ['bold', 'italic', 'underline'],
                                                            ['link'],
                                                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                            [{ 'align': [] }],
                                                        ],
                                                    }}
                                                    formats={[
                                                        'header',
                                                        'bold', 'italic', 'underline',
                                                        'link',
                                                        'list', 'bullet',
                                                        'align',
                                                    ]}
                                                    placeholder="Conteúdo do Termo"
                                                    className="custom-textarea mb-5"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Quem Assina este Termo</Form.Label>
                                                <Row>
                                                    {Object.keys(papeisAssinatura).map((papel) => (
                                                        <Col xs={6} sm={2} key={`papel-${papel}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                            <Form.Check 
                                                                type="checkbox"
                                                                id={`papel-${papel}`}
                                                                label={papeisAssinatura[papel]}
                                                                checked={this.state.quem_assina.includes(papel)}
                                                                onChange={e => this.quemAssinaChange(papel, e.target.checked)}
                                                            />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Variáveis Disponíveis</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form.Group className="mb-3">
                                                <Form.Text as="small">
                                                    <ul className="list-unstyled">
                                                        <li><strong>[exame_nome]</strong> - Exibe o nome do exame. Ex.: “XXXXXX”.</li>
                                                        <li><strong>[paciente_nome]</strong> - Exibe o nome completo do paciente. Ex.: “Marcus Silva.</li>
                                                        <li><strong>[paciente_data_nascimento]</strong> - Exibe a data de nascimento do paciente no seguinte formato dd/mm/aaaa. Ex.: “22/10/1980”.</li>
                                                        <li><strong>[paciente_municipio_nascimento]</strong> - Exibe o município de nascimento do paciente. Ex.: “São Paulo”.</li>
                                                        <li><strong>[paciente_estado_nascimento]</strong> - Exibe o estado de nascimento do paciente. Ex.: “SP”.</li>
                                                        <li><strong>[paciente_nacionalidade]</strong> - Exibe a nacionalidade do paciente. Ex.: “Brasileiro”.</li>
                                                        <li><strong>[paciente_sexo]</strong> - Exibe o sexo do paciente. Ex.: “Masculino” ou “Feminino”.</li>
                                                        <li><strong>[paciente_estado_civil]</strong> - Exibe o estado civil do paciente. Ex.: “Solteiro”.</li>
                                                        <li><strong>[paciente_nome_mae]</strong> - Exibe o nome completo da mãe do paciente. Ex.: “Maria Sila.</li>
                                                        <li><strong>[paciente_profissao]</strong> - Exibe a profissão do paciente. Ex.: “Engenheiro”.</li>
                                                        <li><strong>[paciente_cpf]</strong> - Exibe o CPF do paciente. Ex.: “123.456.789-00”.</li>
                                                        <li><strong>[paciente_rg]</strong> - Exibe o RG do paciente. Ex.: “12.345.678-9”.</li>
                                                        <li><strong>[paciente_endereco]</strong> - Exibe o endereço do paciente. Ex.: “Rua das Flores, 123”.</li>
                                                        <li><strong>[paciente_cep]</strong> - Exibe o CEP do paciente. Ex.: “12345-678”.</li>
                                                        <li><strong>[paciente_bairro]</strong> - Exibe o bairro do paciente. Ex.: “Centro”.</li>
                                                        <li><strong>[paciente_cidade]</strong> - Exibe a cidade do paciente. Ex.: “São Paulo”.</li>
                                                        <li><strong>[paciente_uf]</strong> - Exibe o estado do paciente. Ex.: “SP”.</li>
                                                        <li><strong>[paciente_telefone]</strong> - Exibe o telefone fixo do paciente. Ex.: “(11) 1234-5678”.</li>
                                                        <li><strong>[paciente_celular]</strong> - Exibe o número de celular do paciente. Ex.: “(11) 98765-4321”.</li>
                                                        <li><strong>[paciente_email]</strong> - Exibe o email do paciente. Ex.: “carlos.souza@email.com”.</li>
                                                        <li><strong>[paciente_local]</strong> - Exibe o local associado ao paciente. Ex.: “Clínica ABC”.</li>
                                                        <li><strong>[responsavel_nome]</strong> - Exibe o nome completo do responsável. Ex.: “João Silva”.</li>
                                                        <li><strong>[responsavel_cpf]</strong> - Exibe o CPF do responsável. Ex.: “987.654.321-00”.</li>
                                                        <li><strong>[responsavel_endereco]</strong> - Exibe o endereço do responsável. Ex.: “Av. Paulista, 456”.</li>
                                                        <li><strong>[responsavel_celular]</strong> - Exibe o número de celular do responsável. Ex.: “(11) 99876-5432”.</li>
                                                        <li><strong>[responsavel_local]</strong> - Exibe o local associado ao responsável. Ex.: “Clínica XYZ”.</li>
                                                        <li><strong>[profissional_nome]</strong> - Exibe o nome completo do profissional. Ex.: “Dr. Carlos Souza”.</li>
                                                        <li><strong>[profissional_registro]</strong> - Exibe o número de registro do profissional. Ex.: “CRM 12345”.</li>
                                                        <li><strong>[profissional_registro_uf]</strong> - Exibe o estado do registro do profissional. Ex.: “SP”.</li>
                                                        <li><strong>[profissional_email]</strong> - Exibe o email do profissional. Ex.: “dr.carlos.souza@email.com”.</li>
                                                        <li><strong>[data]</strong> - Exibe a data atual. Ex.: “01/01/2025”.</li>
                                                        <li><strong>[local]</strong> - Exibe o local atual. Ex.: “Hospital ABC”.</li>
                                                    </ul>
                                                </Form.Text>
                                            </Form.Group>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={this.handleCloseModal}>
                                                Fechar
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>  

                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(TermosEdit);